export default {
  create_title: 'Aggiungi endpoint webhook',
  edit_title: 'Modifica endpoint webhook',
  form: {
    url: 'URL endpoint HTTPS',
    description: 'Descrizione',
    description_placeholder: 'es. Eventi ordine per il POS',
    events: 'Eventi da consegnare',
    events_required: 'Seleziona almeno un evento.',
    events_hint: 'Solo gli eventi selezionati vengono inviati a questo endpoint.',
    events_selected: '{{selected}} di {{total}}',
    event_groups: {
      order: 'Ordini',
      store: 'Negozio',
      product: 'Prodotti',
      modifier: 'Modificatori',
      menu_push: 'Pubblicazioni menu',
      payout: 'Pagamenti',
    },
    status: 'Stato',
    status_active: 'Attivo',
    status_disabled: 'Disabilitato',
    status_auto_disabled: 'Disabilitato automaticamente (scegli Attivo per riattivare)',
  },
  buttons: {
    cancel: 'Annulla',
    create: 'Crea',
    save: 'Salva',
  },
  toasts: {
    created: 'Endpoint creato.',
    updated: 'Endpoint aggiornato.',
    error: "Impossibile salvare l'endpoint. Riprova.",
  },
};
